import React from 'react'
import DateRenderer from './DateRenderer'

export default (props) => {
  const { value } = props
  return <DateRenderer value={value} formatStr='Pp' />
}
